export default "__VITE_ASSET__CgEJpM9X__"